import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import VModal from "vue-js-modal";
import VueTheMask from "vue-the-mask";

import "bootstrap-css-only/css/bootstrap.min.css";

Vue.use(VModal, { dialog: true });

Vue.use(VueTheMask);

Vue.directive("focus", {
  inserted: function (el) {
    el.focus();
  },
});

Vue.config.productionTip = false;

const Centrifuge = require("centrifuge");

Vue.prototype.$centrifuge = Centrifuge;

new Vue({
  created() {
    const html = document.documentElement;
    html.setAttribute("lang", "ru_RU");
    document.title = "КАССА";
  },
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
